import { createSlice } from '@reduxjs/toolkit';

export const warehouseTotalInfoSlice = createSlice({
    name: 'warehouseTotalInfo',
    initialState: {},
    reducers: {
        loadWarehouseTotalInfo: (state, action) => {
            const totalInfo = {};
            const data = action.payload.data.response.equipment;
            Object.keys(data).forEach((key) => {
                const dataId = data[key].id;
                totalInfo[dataId] = data[key].total_info;
            });
            return Object.assign(state, totalInfo);
        },
        updateWarehouseTotalInfo: (state, action) => {
            const { warehouseId, newTotalInfo } = action.payload;
            state[warehouseId] = newTotalInfo;
        },
        addNewWarehouseTotalInfo: (state, action) => {
            const { warehouseId, totalInfo } = action.payload;
            state[warehouseId] = totalInfo;
        },
        removeWarehouseTotalInfo: (state, action) => {
            delete state[action.payload];
        },
    },
});

export const {
    loadWarehouseTotalInfo,
    updateWarehouseTotalInfo,
    addNewWarehouseTotalInfo,
    removeWarehouseTotalInfo,
} = warehouseTotalInfoSlice.actions;

export const getWarehouseTotalInfoRequest = (payload) => (dispatch) => {
    const url = helpable.replaceUrlParameters(routable.getRoute('getWarehouseTotalInfo'), {
        // eslint-disable-next-line camelcase
        _warehouse_id_: payload,
    });
    fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
    })
        .then((response) => response.json())
        .then((data) => {
            dispatch(
                updateWarehouseTotalInfo({ warehouseId: payload, newTotalInfo: data.response })
            );
        });
};

export default warehouseTotalInfoSlice.reducer;
